export default __webpack_public_path__ + "static/media/landing-hero2.86cf9a5a.png";